module.exports = __webpack_public_path__ + "img/scroll-up-icon.d642347b.svg";